import React, { createContext, useContext, useEffect, useState } from 'react';
import Cookies from 'universal-cookie';

type AuthContextType = {
  token: string | null,
  updateToken: (newToken: string | null) => void,
  companyId: string | null,
  updateCompanyId: (newId: string | null) => void,
  logout: () => void,
};

const AuthContext = createContext<AuthContextType>({
  token: null,
  companyId: null,
  updateToken: () => { },
  updateCompanyId: () => { },
  logout: () => { },
});

export const useAuth = () => useContext(AuthContext);

type AuthProviderProps = {
  children: React.ReactNode;
};

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [token, setToken] = useState<string | null>(null);
  const [companyId, setCompanyId] = useState<string | null>(null);
  const cookies = new Cookies();
  useEffect(() => {
    const tempToken = cookies.get('token');
    const tempCompanyId = cookies.get('companyId');
    if (tempToken) {
      setToken(tempToken);
    } 
    if (tempCompanyId) {
      setCompanyId(tempCompanyId);
    }
  }, []);

  const updateToken = (newToken: string | null) => {
    setToken(newToken);
    if (newToken) {
      cookies.set('token', newToken);
    } else {
      cookies.remove('token');
    }
  };

  const updateCompanyId = (newId: string | null) => {
    setCompanyId(newId);
    if (newId) {
      cookies.set('companyId', newId);
    } else {
      cookies.remove('companyId');
    }
  };

  const logout = () => {
    updateToken(null);
    updateCompanyId(null);
  };

  return (
        <AuthContext.Provider value={{ token, companyId, updateToken, updateCompanyId, logout }}>
            {children}
        </AuthContext.Provider>
  );
};

export default AuthProvider;
